// TableComponent.tsx
import React from "react";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  flexRender,
  SortingState,
  Column,
} from "@tanstack/react-table";

interface TableData {
  [key: string]: any;
}

interface TableProps {
  DATA: TableData[];
  COLUMNS: Column<TableData>[];
  sorting: any;
  setSorting: any;
}

export default function TableComponent({
  DATA,
  COLUMNS,
  sorting,
  setSorting,
}: TableProps) {
  const table = useReactTable({
    data: DATA,
    columns: COLUMNS,
    state: {
      sorting,
    },
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting,
  });

  return (
    <div className="overflow-x-auto ">
      <div className="min-w-full inline-block  align-middle">
        <div className="shadow overflow-hidden  sm:rounded-lg">
          <table className="min-w-full divide-y divide-gray-200 table-auto">
            <thead className="bg-gray-100">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header, i) => (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      onClick={header.column.getToggleSortingHandler()}
                      className={`px-4 py-3 text-left text-sm text-primary-300 bg-[#F7F8F9] font-semibold tracking-wider cursor-pointer whitespace-nowrap ${
                        i === 0 ? "sticky left-0 z-10 " : ""
                      }`}
                    >
                      <div className="flex items-center gap-1">
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                        {/* {{
                          asc: (
                            <img
                              src={V_UP}
                              className="w-[10px] h-[10px]"
                              alt=""
                            />
                          ),
                          desc: (
                            <img
                              src={V_DOWN}
                              className="w-[10px] h-[10px]"
                              alt=""
                            />
                          ),
                        }[header.column.getIsSorted() as string] ?? null} */}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id} className="">
                  {row.getVisibleCells().map((cell, i) => (
                    <td
                      key={cell.id}
                      className={`px-4 py-4 whitespace-nowrap text-sm text-[#4D4D4D] ${
                        i === 0 ? "sticky left-0 bg-inherit z-0 shadow-md " : ""
                      }`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
